const SET_NOTIFICATION_MESSAGES = "SET_NOTIFICATION_MESSAGES";
const SET_LAST_READ_VERSION = "SET_LAST_READ_VERSION";
const GET_NOTIFICATION_MESSAGES = "GET_NOTIFICATION_MESSAGES";
const GET_LAST_READ_VERSION = "GET_LAST_READ_VERSION";
export const initialState = {
    notificationMessages: [],
    lastReadVersion: ""
};
export function reducer(appState, action) {
    switch (action.type) {
        case SET_NOTIFICATION_MESSAGES:
            return Object.assign(Object.assign({}, appState), { notificationMessages: action.notificationMessages });
        case SET_LAST_READ_VERSION:
            return Object.assign(Object.assign({}, appState), { lastReadVersion: action.lastReadVersion });
        case GET_NOTIFICATION_MESSAGES:
            return {
                notificationMessages: appState.notificationMessages
            };
        case GET_LAST_READ_VERSION:
            return {
                lastReadVersion: appState.lastReadVersion
            };
        default:
            return initialState;
    }
}
